export default {
  props: {
    color: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    vm: {
      colorClass: '',
    },
  }),
  mounted() {
    if (!this.color) {
      return;
    }

    this.vm.colorClass = `color-${ this.color }`;
  },
};
